import * as Blob_event_bs$SolvuuApi0 from "./blob_event_bs.bs.js";
var Json =
/* alias */
0;
var json_of_event = Blob_event_bs$SolvuuApi0.write_event;
var json_of_id = Blob_event_bs$SolvuuApi0.write_id;
var json_of_job_id = Blob_event_bs$SolvuuApi0.write_job_id;
var json_of_int64 = Blob_event_bs$SolvuuApi0.write_int64;
var json_of_checksum = Blob_event_bs$SolvuuApi0.write_checksum;
var json_of_s3_location = Blob_event_bs$SolvuuApi0.write_s3_location;
var json_of_storage = Blob_event_bs$SolvuuApi0.write_storage;
var json_of_processor_job = Blob_event_bs$SolvuuApi0.write_processor_job;
var json_of_create_upload = Blob_event_bs$SolvuuApi0.write_create_upload;
var json_of_create = Blob_event_bs$SolvuuApi0.write_create;
var json_of_s3_progress_part = Blob_event_bs$SolvuuApi0.write_s3_progress_part;
var json_of_s3_progress_report = Blob_event_bs$SolvuuApi0.write_s3_progress_report;
var json_of_s3_progress = Blob_event_bs$SolvuuApi0.write_s3_progress;
var json_of_progress = Blob_event_bs$SolvuuApi0.write_progress;
var json_of_info = Blob_event_bs$SolvuuApi0.write_info;
var json_of_t = Blob_event_bs$SolvuuApi0.write_t;
var event_of_json = Blob_event_bs$SolvuuApi0.read_event;
var id_of_json = Blob_event_bs$SolvuuApi0.read_id;
var job_id_of_json = Blob_event_bs$SolvuuApi0.read_job_id;
var int64_of_json = Blob_event_bs$SolvuuApi0.read_int64;
var checksum_of_json = Blob_event_bs$SolvuuApi0.read_checksum;
var s3_location_of_json = Blob_event_bs$SolvuuApi0.read_s3_location;
var storage_of_json = Blob_event_bs$SolvuuApi0.read_storage;
var processor_job_of_json = Blob_event_bs$SolvuuApi0.read_processor_job;
var create_upload_of_json = Blob_event_bs$SolvuuApi0.read_create_upload;
var create_of_json = Blob_event_bs$SolvuuApi0.read_create;
var s3_progress_part_of_json = Blob_event_bs$SolvuuApi0.read_s3_progress_part;
var s3_progress_report_of_json = Blob_event_bs$SolvuuApi0.read_s3_progress_report;
var s3_progress_of_json = Blob_event_bs$SolvuuApi0.read_s3_progress;
var progress_of_json = Blob_event_bs$SolvuuApi0.read_progress;
var info_of_json = Blob_event_bs$SolvuuApi0.read_info;
var t_of_json = Blob_event_bs$SolvuuApi0.read_t;
export { Json, json_of_event, json_of_id, json_of_job_id, json_of_int64, json_of_checksum, json_of_s3_location, json_of_storage, json_of_processor_job, json_of_create_upload, json_of_create, json_of_s3_progress_part, json_of_s3_progress_report, json_of_s3_progress, json_of_progress, json_of_info, json_of_t, event_of_json, id_of_json, job_id_of_json, int64_of_json, checksum_of_json, s3_location_of_json, storage_of_json, processor_job_of_json, create_upload_of_json, create_of_json, s3_progress_part_of_json, s3_progress_report_of_json, s3_progress_of_json, progress_of_json, info_of_json, t_of_json };
/* Blob_event_bs-SolvuuApi0 Not a pure module */